import { store } from '@/store/store'

export default class LegendLimitsUtils {
    /**
     * Haetaan legendin raja-arvot konfiguraatiosta
     * @param name Legendin nimi
     * @returns Raja-arvot arrayna
     */
    getLegendLimits(name: string): Array<number> {
        const legendLimits = store.getters.legendLimits as Map<string, string> | null
        const retVal = new Array<number>()

        if (legendLimits != null) {
            const limitsString = legendLimits.get(name)
            if (limitsString !== undefined) {
                const values = limitsString.split(",")
                for (const value of values) {
                    retVal.push(Number(value.trim()))
                }
            }
        }
        return retVal
    }
}
